import React from 'react';
import styles from './index.module.less';
import type { IHonorDataItem } from '../../model';

interface IProps {
    title: string;
    honorData: IHonorDataItem[];
}

const CompFourFooter: React.FC<IProps> = (props) => {
    return (
        <div className={ `${styles['four-footer']} text-center` }>
            <h3 className={ styles['four-footer-title'] }>{props.title}</h3>
            <div className={ styles['four-footer-content'] }>
                {props.honorData.map((item) => {
                    return (
                        <div
                            key={ item.title }
                            className={ styles['four-footer-honor'] }>
                            <img
                                alt=""
                                src={ item.image } />
                            <h5 className={ styles['honor-title'] }>{item.title}</h5>
                            <h6 className={ styles['honor-desc'] }>{item.desc}</h6>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};
export default CompFourFooter;
